import clsx from 'clsx'
import {FC, PropsWithChildren, useMemo} from 'react'
import {HeaderProps} from 'react-table'
import {initialQueryState} from '../../../../../../../../template/helpers'
import {useQueryRequest} from '../../../../../../../../template/helpers/QueryRequestProvider'
import {IBitrixUserModel} from '../../../../../../../../types/apps/crm/biitrix24/BitrixUserModel'
import {useIntl} from 'react-intl'

type Props = {
  className?: string
  title?: string
  tableProps: PropsWithChildren<HeaderProps<IBitrixUserModel>>
}
const BitrixUserCustomHeader: FC<Props> = ({className, title, tableProps}) => {
  const intl = useIntl()
  const id = tableProps.column.id
  const {state, updateState} = useQueryRequest()

  const isSelectedForSorting = useMemo(() => {
    return state.sort && state.sort === id
  }, [state, id])
  const order: 'asc' | 'desc' | undefined = useMemo(() => state.order, [state])

  const sortColumn = () => {
    // avoid sorting for these columns
    if (id === 'actions' || id === 'selection') {
      return
    }

    if (!isSelectedForSorting) {
      // enable sort asc
      updateState({sort: id, order: 'asc', ...initialQueryState})
      return
    }

    if (isSelectedForSorting && order !== undefined) {
      if (order === 'asc') {
        // enable sort desc
        updateState({sort: id, order: 'desc', ...initialQueryState})
        return
      }

      // disable sort
      updateState({sort: undefined, order: undefined, ...initialQueryState})
    }
  }

  return (
    <th
      {...tableProps.column.getHeaderProps()}
      className={clsx(className, isSelectedForSorting && order !== undefined && `table-sort-${order}`)}
      style={{cursor: 'pointer'}}
      onClick={sortColumn}
    >
      {title === 'Bitrix24 ID' && intl.formatMessage({id: 'APPS.SETTINGS.BITRIX24.LINES.HEADER.USERID'})}
      {title === 'Name' && intl.formatMessage({id: 'APPS.SETTINGS.BITRIX24.USERS.NAME'})}
      {title === 'Number' && intl.formatMessage({id: 'APPS.SETTINGS.BITRIX24.USERS.NUMBER'})}
      {title === 'Email' && intl.formatMessage({id: 'EMAIL.LABEL'})}
    </th>
  )
}

export {BitrixUserCustomHeader}
